import { Component, OnInit, AfterViewInit } from '@angular/core';
import {Location} from '@angular/common';
declare var $: any;

@Component({
  selector: 'app-trucks-managment',
  templateUrl: './trucks-managment.component.html',
  styleUrls: ['./trucks-managment.component.css']
})
export class TrucksManagmentComponent implements OnInit, AfterViewInit {

  constructor(private location: Location) { }

  ngOnInit() {
  }

  ngAfterViewInit(): void {

    // slide the content 
    $(window).scroll(function () {
      $(".slideanim").each(function () {
        var pos = $(this).offset().top;
        var winTop = $(window).scrollTop();
        if (pos < winTop + 780) {
          $(this).addClass("slide");
        }
      });
    });
  }
  public back(){
    this.location.back();
  }
}
